import React, { memo } from "react";

import { Col, Row } from "react-grid-system";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { useMount } from "react-use";

import List from "@app/components/atoms/List/List";
import Loading from "@app/components/atoms/Loading/Loading";
import { Paragraph, Title } from "@app/components/atoms/Typography/Typography";
import ContentWrapper from "@app/components/layouts/ContentWrapper/ContentWrapper";
import DefaultLayout from "@app/components/layouts/DefaultLayout/DefaultLayout";
import Section from "@app/components/layouts/Section/Section";
import PractitionersList from "@app/components/renderings/PractitionersList/PractitionersList";
import { ThemeEnum } from "@app/constants/theme.constants";
import { RootState } from "@app/redux/root-reducer";
import { useAppDispatch } from "@app/redux/store";

import {
  getPractitioners,
  getPractitionersAppend,
} from "../../redux/practitioners.slice";
import styles from "./PractitionersScreen.module.scss";

const PractitionersScreen = memo(() => {
  const { t } = useTranslation();
  const { practitioners, loading, loadingMore } = useSelector(
    (state: RootState) => state.practitioners
  );
  const dispatch = useAppDispatch();

  const handleLoadMore = () => {
    dispatch(
      getPractitionersAppend({
        page: practitioners.pagination.current_page + 1,
      })
    );
  };

  useMount(() => {
    dispatch(getPractitioners({ page: 1 }));
  });

  return (
    <DefaultLayout>
      <Section theme={ThemeEnum.KHAKI} className={styles.container}>
        <ContentWrapper className={styles.titleContainer}>
          <Title level={1} isGoldGradient className={styles.title}>
            {t("practitionersPage.pageTitle")}
          </Title>
          <Row justify="center" className={styles.subTitle}>
            <Col xs={12} lg={10} xl={8}>
              <Paragraph level={1}>
                {t("practitionersPage.pageSubTitle")}
              </Paragraph>
            </Col>
          </Row>
        </ContentWrapper>
        <Loading isLoading={loading}>
          <div className={styles.practitioners}>
            <List
              onLoadMore={handleLoadMore}
              isLoading={loading}
              pagination={practitioners.pagination}
              isLoadingMore={loadingMore}
            >
              <PractitionersList items={practitioners.data} />
            </List>
          </div>
        </Loading>
      </Section>
    </DefaultLayout>
  );
});

export default PractitionersScreen;
